import {
  FETCH_DATA,
  SET_IS_MODAL_OPEN,
  SET_STATUS,
  FETCH_TEXT,
} from '../constants';

const initialState = {
  persons: [],
  user: null,
  texts: {},
  isModalOpen: false,
  modalContentId: null,
  isAuth: false,
  flow: '',
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_DATA:
      return {
        ...state,
        persons: payload.categories?.[0]?.contents,
        user: payload.user,
        isAuth: payload.authorized,
      };

    case FETCH_TEXT:
      return {
        ...state,
        texts: {
          ...state.texts,
          [payload.alias]: payload.text,
        },
      };

    case SET_IS_MODAL_OPEN:
      return { ...state, ...payload };

    case SET_STATUS:
      return {
        ...state,
        flow: payload.flow_url,
        isAuth: payload.authorized,
      };

    default:
      return state;
  }
};
